import { render } from "./AdminInfractions.vue?vue&type=template&id=52186f22"
import script from "./AdminInfractions.vue?vue&type=script&lang=js"
export * from "./AdminInfractions.vue?vue&type=script&lang=js"

import "./AdminInfractions.vue?vue&type=style&index=0&id=52186f22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__